import { createFileRoute } from '@tanstack/react-router'
import { organizationInvitation } from '@/lib/queries/organization-invitations'
import { organizationMembership } from '@/lib/queries/organization-memberships'
import { Users } from '@/features/users'

export const Route = createFileRoute('/_authenticated/org/$orgId/users/')({
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.query({
        ...organizationMembership.findManyByOrg(params.orgId),
        staleTime: 'static',
      }),
      context.queryClient.query({
        ...organizationInvitation.findManyPendingByOrg(params.orgId),
        staleTime: 'static',
      }),
    ])
  },
  component: Users,
})
